<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: true,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      // console.log("submitted");
      this.$emit('setpage', 8);
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Listing is complete.png')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="font-22 mb-3" data-aos="fade-zoom-in">Listing is complete</h3>
        <p class="text-muted" data-aos="fade-zoom-in">You listing is complete. We appreciate your business. Please keep us in mind for any future transactions.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
